import React from 'react';
import { SoftTag } from './SoftTag';

/** Whether a service is charged by the hour (Labour) or at a fixed price (Fixed). */
export const ServiceTypeTag: React.FC<{ isFixed?: boolean; style?: React.CSSProperties }> = ({
  isFixed,
  style,
}) => (
  <SoftTag group={isFixed ? 'grey' : 'blue'} style={style}>
    {isFixed ? 'Fixed' : 'Labour'}
  </SoftTag>
);
